// Creates a Promise that resolves after a specified delay.
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//# sourceMappingURL=delay.js.map